import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../providers/AuthContext';
import api from '../../API';
import styles from './NetworkDescription.module.css';

function getLocal(networkData) {
    if(!networkData) return '<Unknown>';
    return networkData.isHub ? networkData.hub : networkData.spokes.find(spoke => spoke.girderNetworkUuid === networkData.localGirderNetworkUuid);
}

function NetworkDescription({ onViewNetwork }) {
    const { girderInfo, user } = useAuth();
    
    // Query network description
    // Use consistent query key with NetworkDiagram.js to share cache
    const { data: networkResponse } = useQuery({ 
        queryKey: ['network-describe-public'], 
        queryFn: () => api.get('network/describe/public'),
        enabled: !!girderInfo && girderInfo !== 'pending',
        staleTime: 2 * 60 * 1000, // 2 minutes - network data doesn't change frequently
        refetchOnMount: false, // Don't refetch if data is fresh
        refetchOnWindowFocus: false, // Don't refetch on window focus
    });
    
    const networkData = networkResponse?.data;
    
    const localNode = getLocal(networkData);
    const localDisplayName = localNode?.displayName ?? '<Unknown>';
    const localNetworkId = localNode?.networkIdentifier ?? '<Unknown>';
    const networkName = (networkData?.network?.networkInfo?.networkName || networkData?.network?.networkName) ?? '<Unknown>';

    
    return (
        <div className={styles.networkDescription}>
            You are at <strong>{localDisplayName}</strong> (<strong>{localNetworkId}</strong>), part of the <strong>{networkName}</strong> network. View the <a href="#" onClick={onViewNetwork}>network diagram</a> below.
        </div>
    );
}

export default NetworkDescription;

